import React from "react";
import PropTypes from "prop-types";
import formatter from "../../utils/formatter";
import { CurrencyInputField } from "./styles";

class CurrencyInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isEditing: false };
  }

  componentDidMount() {
    if (this.props.focus) this.currencyInput.focus();
  }

  onChange = event => {
    this.props.onChange && this.props.onChange(event);
  };

  toFormat = value => {
    if (!value) return undefined;
    const formattedValue = formatter({ value, fieldSuffix: "Dollars" });
    return formattedValue;
  };

  onBlur = event => {
    this.setState({ isEditing: !this.state.isEditing });
    this.props.onBlur && this.props.onBlur(event);
  };

  onFocus = () => {
    this.setState({ isEditing: !this.state.isEditing });
  };

  render() {
    return (
      <div>
        {this.state.isEditing ? (
          <CurrencyInputField
            type="text"
            aria-label={this.props.label}
            name={this.props.name}
            id={this.props && this.props.id}
            placeholder={this.props.placeholder}
            value={this.props.value}
            disabled={this.props.disabled}
            maxLength={this.props.maxLength}
            onChange={this.onChange}
            onBlur={this.onBlur}
            className={this.props.className}
            fullWidth={this.props.fullWidth}
          />
        ) : (
          <CurrencyInputField
            ref={input => {
              this.currencyInput = input;
            }}
            aria-label={this.props.label}
            type="text"
            name={this.props.name}
            id={this.props && this.props.id}
            disabled={this.props.disabled}
            maxLength={this.props.maxLength}
            placeholder={this.props.placeholder}
            value={this.toFormat(this.props.value)}
            onFocus={this.onFocus}
            readOnly={false}
            className={this.props.className}
            fullWidth={this.props.fullWidth}
          />
        )}
      </div>
    );
  }
}

CurrencyInput.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  maxLength: PropTypes.number,
  placeholder: PropTypes.string
};

export default CurrencyInput;
